// extracted by mini-css-extract-plugin
export default {"root":"Screen_root__jS18v","header":"Screen_header__i0XY1","screenWrap":"Screen_screenWrap__lg9Gi","reducePaddingRight":"Screen_reducePaddingRight__4TMeq"};